<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3 text-center">
          <h1 class="title">Choose a new password</h1>

          <div v-if="isDone">
            <img src="/static/images/check.svg" class="m-4" width="96px" />
            <p>All done.</p>
            <router-link class="btn btn-primary mt-2" :to="{ name: 'dashboard' }">Go to Dashboard</router-link>
          </div>
          <div v-else-if="isLoading" class="text-center">
            <hr class="space space-sm">
            <loader size="128px"></loader>
            <p class="small muted pt-4">Here we go...</p>
          </div>
          <div v-else>
            <b-form @submit.prevent="submit">
              <b-form-group label="Your new password:">
                <b-form-input id="password"
                              type="password"
                              ref="password"
                              v-model="form.password"
                              required>
                </b-form-input>
              </b-form-group>
              <div class="error" v-if="hasError">
                {{ this.errorInfo }}
              </div>
              <b-button type="submit" variant="primary">Set Password</b-button>
            </b-form>
          </div>

          <hr class="space space-sm">
        </div>
      </div>
    </div>
    <hr class="divider">
  </div>
</template>

<script>
export default {
  name: 'password-change',
  data () {
    return {
      form: {
        password: null
      },
      isLoading: false,
      isDone: false,
      hasError: false,
      errorInfo: null
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$refs.password.$el.focus()
  },
  methods: {
    submit () {
      this.isLoading = true
      this.isDone = false
      this.$store.dispatch('PASSWORD_CHANGE', this.form).then((response) => {
        this.isLoading = false
        this.isDone = true
      }).catch(error => {
        console.log(error)
        this.isLoading = false
        this.hasError = true
        this.errorInfo = 'Something didn\'t work. Please try again.'
      })
    }
  },
  computed: {
  },
  created () {
  }
}
</script>

<style lang="scss">
</style>
